import React from 'react';
import {injectIntl} from 'react-intl';
import Icon from '@Components/Icon';

const RangeFilter = ({intl, range, setRange}) => {
  const onChange = (event) => {
    event.preventDefault();
    setRange((prev) => {
      return {
        ...prev,
        radius: event.target.value,
      };
    });
  };

  return (
    <>
      <label className="form-group__label" htmlFor="range">{intl.formatMessage({id: 'RangeFilter.Label'})}</label>
      <div className="form-group__input">
        <select
          className={range ? '' : 'untouched'}
          id="range"
          name="range"
          onChange={onChange}
          value={range ? range : '_none'}
        >
          <option key="_none" value="_none" hidden disabled>{intl.formatMessage({id: 'RangeFilter.FilterPlaceholder'})}</option>,
          <option key={5} value={5}>{intl.formatMessage({id: 'RangeFilter.Options'}, {number: 5})}</option>
          <option key={10} value={10}>{intl.formatMessage({id: 'RangeFilter.Options'}, {number: 10})}</option>
          <option key={25} value={25}>{intl.formatMessage({id: 'RangeFilter.Options'}, {number: 25})}</option>
          <option key={50} value={50}>{intl.formatMessage({id: 'RangeFilter.Options'}, {number: 50})}</option>
          <option key={100} value={100}>{intl.formatMessage({id: 'RangeFilter.Options'}, {number: 100})}</option>
        </select>
        <span className="select-arrow icon">
          <Icon type="chevron-down"/>
        </span>
      </div>
    </>

  );
};

export default injectIntl(RangeFilter);
